import React from 'react';
import Docs from '../Docs/CurriculumVitaeEnglish.pdf'





class PrincipalPage extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">





                    <div className="sectionOneP">


                        <div className="titleSectionOne">
                            <h1 className="noneSelect">Frontend Developer</h1>
                            <h1 className="james">Brandon James Grimaldo Moscote</h1>
                        </div>
                        <svg> <rect></rect> </svg>


                        <p>
                            I’m a frontend web developer passionate about technology, development with multiple technologies
                            that I have learned in my studies in computer engineering, I have knowledge in relational databases,
                            object-oriented programming, user interface design and project formulation techniques. <br /> <br />
                            I really like learning about new technological trends, I’m autodidactic, I invest time to learn new
                            technologies that I can apply to solve the problems that arise as a developer. <br /><br />
                            Currently I’m very focused on frontend web development in a professional way, applying
                            the technologies that best adapt to the client's needs, making use of good SEO practices
                            and responsive design.

                        </p>

                        <a href={Docs} download="CurriculumVitaeEnglish.pdf" rel='noreferrer'>
                        <button className="animateButton"> <p>Curriculum PDF </p> </button>
                        </a>

                        <a href="https://www.canva.com/design/DAEwr-TB2Xc/vHAniCrd_t2YcrQsXR2pRQ/view?website#1" target="_blank" rel="noreferrer">
                            <button className="animateButton"> <p>Curriculum WEB </p></button>

                        </a>
                    </div>




                </div>


            </React.Fragment>
        );
    }
}

export default PrincipalPage;